import React, { useEffect, useRef, useState } from "react";
import { images } from "../../constants/index";
import { Col, Row } from "react-bootstrap";
import "./ownerShopProfile.css";
import NotificationsIcon from "@mui/icons-material/Notifications";
import TimelineIcon from "@mui/icons-material/Timeline";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import StoreIcon from "@mui/icons-material/Store";
import StarRateIcon from "@mui/icons-material/StarRate";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ReportIcon from "@mui/icons-material/Report";
import SettingsIcon from "@mui/icons-material/Settings";
import CampaignIcon from "@mui/icons-material/Campaign";
import VideoCallIcon from "@mui/icons-material/VideoCall";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import { useSelector } from "react-redux";
import {
  useGetVendorLikeDislikeQuery,
  useGetShopRatingQuery,
  useGetSubscriptionPurchasesByShopQuery,
} from "../../features/shop/shopApiSlice";
import { useGetMyManagedShopsQuery } from "../../features/shop/shopMemberApiSlice";
import { decodeId } from "../../utils/idObfuscator";
import Salespromotion from "../../components/salespromotion_modal";
import FiberManualRecordSharpIcon from "@mui/icons-material/FiberManualRecordSharp";
import Qrmodal from "../QRmodal/Qrmodal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Desmodal from "../Des_Modal";
import { getAsset } from "../../helpers/helper";
import BackArrow from "../backArrow";
import ShopStarRankLink from "../ShopStarRank/ShopStarRankLink";

const OwnerShopProfile = ({
  shopData,
  navigateTo,
  Name,
  setSuggest,
  salespromotion,
  icon,
  suggestdatta,
  shopid,
  Add,
}) => {
  const { id } = useParams();
  const { name } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [imgError, setImgError] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [desshow, setDesshow] = useState(false);
  const [addrShow, setAddrShow] = useState(false);
  const [showAddrReadMore, setShowAddrReadMore] = useState(false);
  const addrRef = useRef(null);

  const targetShopEntityId = shopData?._id || shopid;

  const { data: likeDislikeResponse } = useGetVendorLikeDislikeQuery(
    targetShopEntityId,
    {
      skip: !targetShopEntityId,
    },
  );
  const { data: ratingResponse } = useGetShopRatingQuery(targetShopEntityId, {
    skip: !targetShopEntityId,
  });
  const { data: purchaseResponse, isLoading: isPurchaseLoading } =
    useGetSubscriptionPurchasesByShopQuery(targetShopEntityId, {
      skip: !targetShopEntityId,
    });

  const likeDislikeItem = Array.isArray(likeDislikeResponse?.data)
    ? likeDislikeResponse.data[0]
    : null;
  const TLike = likeDislikeItem?.Tlike ?? 0;
  const TDislike = likeDislikeItem?.Tdislike ?? 0;
  const rawRatingVal =
    ratingResponse?.data?.averageRating ??
    shopData?.averageRating ??
    shopData?.ratings ??
    shopData?.rating ??
    0;
  const showrating = Number(rawRatingVal || 0).toFixed(1);
  const totalReviews =
    ratingResponse?.data?.totalRatings ??
    shopData?.totalRatings ??
    shopData?.reviewsCount ??
    0;
  const subscriptionData = purchaseResponse?.data || purchaseResponse;
  const isHiredSuccess = subscriptionData?.paymentStatus === "success";
  const currentPlan = ["Free", "Basic", "Standard", "Premium"].includes(
    subscriptionData?.planId?.planName,
  )
    ? subscriptionData.planId.planName
    : null;

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Click on address to view map
    </Tooltip>
  );

  const goliveTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Coming Soon
    </Tooltip>
  );

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const closemodal = () => setShowmodal(false);

  const handleClosedes = () => setDesshow(false);
  const handleShowdes = () => setDesshow(true);
  const handleCloseAddr = () => setAddrShow(false);
  const handleShowAddr = () => setAddrShow(true);

  useEffect(() => {
    if (shopData?.businessType) {
      localStorage.setItem("BTtogetMarketer", shopData.businessType);
    }
    if (shopData?._id) {
      const sId = String(shopData._id);
      localStorage.setItem("shopid", sId);
      localStorage.setItem("OpenShopIdForMarketingByMarketer", sId);
    }
  }, [shopData]);

  const goHireMarketers = () => {
    if (shopData?.businessType) {
      localStorage.setItem("BTtogetMarketer", shopData.businessType);
    }
    if (shopData?._id) {
      const sId = String(shopData._id);
      localStorage.setItem("shopid", sId);
      localStorage.setItem("OpenShopIdForMarketingByMarketer", sId);
    }
    navigate("/hire-marketers");
  };

  useEffect(() => {
    setImgError(false);
  }, [shopData?.image]);

  useEffect(() => {
    const el = addrRef.current;
    const text = shopData?.shopaddress || "";
    if (!el || !text) {
      setShowAddrReadMore(false);
      return;
    }
    const checkOverflow = () => {
      setShowAddrReadMore(el.scrollHeight > el.clientHeight + 1);
    };
    checkOverflow();
    const ro =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(checkOverflow)
        : null;
    ro?.observe(el);
    window.addEventListener("resize", checkOverflow);
    return () => {
      ro?.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [shopData?.shopaddress]);

  const [isHiredMarketer, setIsHiredMarketer] = useState(false);
  const [shopHasMarketer, setShopHasMarketer] = useState(false);

  useEffect(() => {
    const marketerId = localStorage.getItem("MeAsmarketerId");
    const marketerUserId = localStorage.getItem("MeAsmarketerUserId");
    const nameUser = name?._id?.toString();

    // The logged-in user is the marketer managing this shop
    setIsHiredMarketer(
      Boolean(marketerId && marketerUserId && marketerUserId === nameUser),
    );

    // The shop has a marketer hired (from the perspective of the owner)
    setShopHasMarketer(
      Boolean(marketerId && marketerUserId && marketerUserId !== nameUser),
    );
  }, [name?._id]);
  const FEATURES = {
    LIKE: "like",
    DISLIKE: "dislike",
    SUGGESTIONS: "suggestions",
    REPORT: "report",
    SETTINGS: "settings",
    STATISTICS: "statistics",
    ADS: "ads",
    GOLIVE: "golive",
    PROMOTION: "promotion",
  };

  const PLAN_FEATURES = {
    Free: [],
    Basic: [FEATURES.ADS, FEATURES.SUGGESTIONS, FEATURES.REPORT],
    Standard: [FEATURES.ADS, FEATURES.SUGGESTIONS, FEATURES.REPORT],
    Premium: [FEATURES.ADS, FEATURES.SUGGESTIONS, FEATURES.REPORT],
  };
  const MENU_ITEMS = [
    {
      key: FEATURES.LIKE,
      label: `Liked by ${TLike}`,
      icon: <ThumbUpIcon className="silver-icon" />,
    },
    {
      key: FEATURES.DISLIKE,
      label: `Unliked by ${TDislike}`,
      icon: <ThumbDownIcon className="silver-icon" />,
    },
    {
      key: FEATURES.SUGGESTIONS,
      label: "Suggestions",
      icon: <NotificationsIcon className="silver-icon" />,
      action: () => {
        setSuggest(1);
        suggestdatta();
      },
    },
    {
      key: FEATURES.REPORT,
      label: "Report",
      icon: <ReportIcon className="silver-icon" />,
      action: () => setSuggest(2),
    },
    {
      key: FEATURES.SETTINGS,
      label: "Setting",
      icon: <SettingsIcon className="silver-icon" />,
      action: () =>
        location.pathname === `/used-vehicle-profile/${id}`
          ? navigate(`/usedvehicle-setting/${shopData?.shopid}`)
          : navigate(`/shop-setting/${shopData?.shopid}`),
    },
    {
      key: FEATURES.STATISTICS,
      label: "View your marketing statistics",
      icon: <TimelineIcon className="silver-icon" />,
      action: () => {
        const sid = shopData?._id || shopid || id;
        if (sid) {
          localStorage.setItem("OpenShopIdForMarketingByMarketer", sid);
          localStorage.setItem("shopid", sid);
        }
        navigate(
          sid ? `/shop-side-statistics/${sid}` : `/shop-side-statistics`,
        );
      },
    },
    {
      key: FEATURES.ADS,
      label: "Ads and promotion",
      icon: <CampaignIcon className="silver-icon" />,
      action: () => navigate(`/promote-shop/${shopData?.shopid}`),
    },
    {
      key: FEATURES.GOLIVE,
      label: "Go Live",
      icon: <VideoCallIcon className="silver-icon" />,
      wrapper: "overlay", // special case
    },
    {
      key: FEATURES.PROMOTION,
      label: salespromotion,
      icon: icon,
      action: handleShow,
    },
  ];

  let allowedFeatures;
  const nameUser = name?._id?.toString();
  const shopUserId =
    shopData?.userid?._id?.toString?.() || shopData?.userid?.toString?.();
  const isOwner = Boolean(nameUser && shopUserId && shopUserId === nameUser);

  const cleanShopId = decodeId(shopid || id) || shopid || id || "";
  const { data: managedShopsRes } = useGetMyManagedShopsQuery(undefined, {
    skip: !nameUser || isOwner,
  });

  const currentMembership = (managedShopsRes?.data?.managedShops || []).find(
    (m) => {
      const sId = m?.shopId?._id || m?.shopId;
      return (
        sId &&
        (String(sId) === String(cleanShopId) ||
          String(sId) === String(shopid) ||
          String(sId) === String(id) ||
          String(m?._id) === String(cleanShopId))
      );
    },
  );

  const isManagedMember = Boolean(currentMembership);
  const memberAccessAreas = currentMembership?.accessAreas || [];

  if (isOwner) {
    // Shop owner always gets full access
    allowedFeatures = Object.values(FEATURES);
  } else if (isManagedMember) {
    // Managed member only gets features corresponding to granted accessAreas
    const memberFeatures = [FEATURES.LIKE, FEATURES.DISLIKE];
    if (memberAccessAreas.includes("shop-reports")) {
      memberFeatures.push(FEATURES.SUGGESTIONS, FEATURES.REPORT);
    }
    if (memberAccessAreas.includes("business-dashboard")) {
      memberFeatures.push(FEATURES.STATISTICS);
    }
    allowedFeatures = memberFeatures;
  } else if (isHiredMarketer) {
    // Hired marketer gets access restricted by the subscription plan
    allowedFeatures = PLAN_FEATURES[currentPlan] || [];
  } else {
    // Non-owner / unauthorized: minimal view
    allowedFeatures = [FEATURES.LIKE, FEATURES.DISLIKE];
  }

  const allowedMenuItems = MENU_ITEMS.filter((item) =>
    allowedFeatures.includes(item.key),
  );
  const goLiveIndex = allowedMenuItems.findIndex(
    (item) => item.key === FEATURES.GOLIVE,
  );
  const fixedMenuItems =
    goLiveIndex >= 0
      ? allowedMenuItems.slice(0, goLiveIndex + 1)
      : allowedMenuItems;
  const scrollMenuItems =
    goLiveIndex >= 0 ? allowedMenuItems.slice(goLiveIndex + 1) : [];
  const renderMenuItem = (item) => {
    if (item.wrapper === "overlay") {
      return (
        <OverlayTrigger
          key={item.key}
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={goliveTooltip}
        >
          <div className="d-flex align-items-center cursor_P">
            {item.icon}
            <p className="mb-0 ViewlabelText ps-2">{item.label}</p>
          </div>
        </OverlayTrigger>
      );
    }

    return (
      <div
        key={item.key}
        className={`d-flex align-items-center ${item.action ? "cursor_P" : ""}`}
        onClick={item.action}
      >
        {item.icon}
        <p className="mb-0 ViewlabelText ps-2">{item.label}</p>
      </div>
    );
  };

  return (
    <>
      <Desmodal
        desshow={desshow}
        handleClosedes={handleClosedes}
        des={shopData?.description}
        title="Description"
      />
      <Desmodal
        desshow={addrShow}
        handleClosedes={handleCloseAddr}
        des={shopData?.shopaddress}
        title="Address"
      />
      <Qrmodal
        show={showmodal}
        handleClosemodal={closemodal}
        id={id}
        readableId={shopData?.shopid}
      />
      <Salespromotion
        shopid={shopid}
        show={show}
        setShow={setShow}
        handleClose={handleClose}
      />

      <Row>
        <Col
          className="shop-profile-box owner-shop-profile-scroll pt-1 px-3 ms-0 me-0 screenHeight pb-5"
          md={12}
          lg={12}
        >
          <div className="owner-shop-profile-fixed">
            <div className="owner-shop-mobile-back d-lg-none">
              <BackArrow />
            </div>
            {isOwner && (
              <div
                className="d-flex justify-content-center pb-2 cursor_P"
                onClick={() => navigate(`${navigateTo}/` + id)}
              >
                <img
                  className="w-img"
                  src={images.UpdateShop}
                  alt="UpdateShop"
                />
                <h6 className="mb-0 ps-2 pt-1 updateSize ">{Name}</h6>
              </div>
            )}

            <div className="relate_div">
              {shopData?.sale?.length > 0 ||
              shopData?.specialOffer?.length > 0 ? (
                <div className="availble_bt0n_2">
                  <span className="font_13" style={{ color: "white" }}>
                    {shopData?.sale}
                  </span>
                </div>
              ) : null}

              <div className="d-flex availble_bt0n">
                <FiberManualRecordSharpIcon
                  style={{ color: "rgb(106 235 64)", fontSize: "19px" }}
                />
                <span>Available</span>
              </div>
              {(() => {
                const rawImg =
                  shopData?.image ||
                  shopData?.images ||
                  shopData?.imageUrl ||
                  shopData?.logo ||
                  shopData?.profileImage ||
                  shopData?.shopImage ||
                  shopData?.coverImage;
                let validImgStr = "";
                if (Array.isArray(rawImg)) {
                  validImgStr =
                    rawImg
                      .flat(Infinity)
                      .find(
                        (i) => i && typeof i === "string" && i.trim() !== "",
                      ) || "";
                } else if (typeof rawImg === "string") {
                  validImgStr = rawImg.trim();
                } else if (rawImg && typeof rawImg === "object") {
                  validImgStr =
                    rawImg.url ||
                    rawImg.image ||
                    rawImg.imageUrl ||
                    rawImg.path ||
                    rawImg.src ||
                    "";
                }
                const finalSrc = validImgStr
                  ? getAsset(validImgStr)
                  : noImagePlaceholder;

                return (
                  <img
                    className="w-100 shop-profile-img"
                    src={finalSrc}
                    alt="Shop image"
                    onError={(e) => {
                      if (e.target.src !== noImagePlaceholder) {
                        e.target.src = noImagePlaceholder;
                      }
                    }}
                  />
                );
              })()}
            </div>

            <div className="box-container mt-1 mb-2">
              {/* <div className="d-flex justify-content-end">
            <QrCodeScannerIcon/>
          </div> */}
              <Row>
                <Col lg="10">
                  <div className="pt-2 pb-1 d-flex">
                    <h4 className="shop-Profile-font mb-0 pb-1">
                      {shopData?.shopname ||
                        shopData?.companyname ||
                        shopData?.profileName ||
                        shopData?.name ||
                        shopData?.title ||
                        "Business Profile"}
                    </h4>
                  </div>
                </Col>
                <Col lg="2">
                  <div className="d-flex justify-content-end align-items-center mt-2">
                    <QrCodeScannerIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowmodal(true)}
                    />
                  </div>
                </Col>
              </Row>
              <ShopStarRankLink shop={shopData} shopId={shopid || id} />

              <Col lg="12" className="d-flex">
                <p
                  className="shop-profile-para mb-0"
                  style={{ wordBreak: "break-word" }}
                >
                  {(
                    shopData?.description ||
                    shopData?.desc ||
                    shopData?.about ||
                    "No description provided."
                  )?.slice(0, 15)}
                </p>
                <p
                  className="shop-profile-para mb-0"
                  style={{ wordBreak: "break-word" }}
                >
                  {(
                    shopData?.description ||
                    shopData?.desc ||
                    shopData?.about ||
                    ""
                  )?.length > 15 && (
                    <span
                      onClick={handleShowdes}
                      className="mb-0 cursor_P font_11 text-dark"
                      style={{ marginTop: "3px" }}
                    >
                      &nbsp;<b>ReadMore...</b>
                    </span>
                  )}
                </p>
              </Col>
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
              >
                <div className="d-flex align-items-start owner-shop-address">
                  <LocationCityIcon className="silver-icon mt-1" />
                  <div className="ps-2 flex-grow-1 min-w-0">
                    <p
                      ref={addrRef}
                      className="mb-0 ViewlabelText pt-1 pb-0 cursor_P owner-shop-address-text"
                    >
                      {(() => {
                        if (!shopData) return "Location not specified";
                        if (
                          typeof shopData.shopaddress === "string" &&
                          shopData.shopaddress.trim()
                        )
                          return shopData.shopaddress.trim();
                        if (
                          typeof shopData.companyaddress === "string" &&
                          shopData.companyaddress.trim()
                        )
                          return shopData.companyaddress.trim();
                        if (
                          typeof shopData.address === "string" &&
                          shopData.address.trim()
                        )
                          return shopData.address.trim();

                        if (
                          shopData.address &&
                          typeof shopData.address === "object"
                        ) {
                          const parts = [
                            shopData.address.street ||
                              shopData.address.addressLine1 ||
                              shopData.address.address,
                            shopData.address.city || shopData.address.town,
                            shopData.address.state,
                            shopData.address.country,
                          ].filter(
                            (p) =>
                              p && typeof p === "string" && p.trim() !== "",
                          );
                          if (parts.length > 0) return parts.join(", ");
                        }

                        const cityParts = [
                          shopData.city ||
                            shopData.resolvedCity ||
                            shopData.MCity,
                          shopData.state,
                          shopData.country,
                        ].filter(
                          (p) => p && typeof p === "string" && p.trim() !== "",
                        );
                        if (cityParts.length > 0) return cityParts.join(", ");

                        if (
                          typeof shopData.location === "string" &&
                          shopData.location.trim()
                        )
                          return shopData.location.trim();
                        if (
                          shopData.location &&
                          typeof shopData.location === "object"
                        ) {
                          if (shopData.location.city)
                            return shopData.location.city;
                          if (shopData.location.address)
                            return shopData.location.address;
                        }

                        return "Location not specified";
                      })()}
                    </p>
                    {showAddrReadMore ? (
                      <button
                        type="button"
                        className="owner-shop-read-more"
                        onClick={handleShowAddr}
                      >
                        Read more
                      </button>
                    ) : null}
                  </div>
                </div>
              </OverlayTrigger>
              <div className="d-flex align-items-center">
                <StoreIcon className="silver-icon" />
                <p
                  className="mb-0 ViewlabelText ps-2"
                  style={{ wordBreak: "break-word" }}
                >
                  {shopData?.marketPlace ||
                    shopData?.businessType ||
                    shopData?.shopCategory?.name ||
                    "Marketplace"}
                </p>
              </div>
            </div>
            {/* details */}
            <div>
              <div>
                <div className="d-flex align-items-center">
                  <StarRateIcon className="silver-icon" />
                  <p className="mb-0 ViewlabelText ps-2">
                    {showrating} ({totalReviews} Reviews)
                  </p>
                </div>
                <div className="d-flex flex-column gap-2">
                  {fixedMenuItems.map(renderMenuItem)}
                </div>
              </div>
            </div>
          </div>
          <div className="owner-shop-profile-overflow">
            {scrollMenuItems.length > 0 && (
              <div className="d-flex flex-column gap-2">
                {scrollMenuItems.map(renderMenuItem)}
              </div>
            )}
            {/* End-btn */}
            <div className="pt-1">
              {isOwner && (
                <>
                  {isPurchaseLoading && (
                    <div className="d-flex justify-content-center my-1">
                      <span
                        className="spinner-border spinner-border-sm text-primary"
                        role="status"
                      />
                    </div>
                  )}
                  {!isPurchaseLoading && (
                    <button
                      onClick={goHireMarketers}
                      className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
                    >
                      Hire Us For Your Marketing & Ads
                    </button>
                  )}
                  <button
                    onClick={() =>
                      navigate(`/add-consultancy-services-profile/${shopid}`)
                    }
                    className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
                  >
                    Add Consultancy Services
                  </button>
                  {/* Shop owners can always add items; marketers need Standard/Premium */}
                  {Add && isOwner && (
                    <button
                      onClick={() => {
                        const businessTypePostPaths = {
                          homemadeShop: "/homemade-postAdd",
                          gemShop: "/minerals-Minning-PostAdd",
                          usedShop: "/useditems-postAdd",
                          rawmaterialShop: "/rawmaterial-postAdd",
                          manufacturerShop: "/manufacturer-postAdd",
                          wholesellerShop: "/wholesaler-postadd",
                          retailerShop: "/newitems-Postadd",
                          recycledShop: "/recycle-postadd",
                          farmingShop: "/farming-postadd",
                        };
                        const postPath =
                          businessTypePostPaths[shopData?.businessType] || "/";
                        navigate(`${postPath}/${id}`);
                      }}
                      className="font_13 border ps-4 pe-4 pt-1 pb-1 mt-1 bg-blue text-white rounded w-100"
                    >
                      {Add}
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default OwnerShopProfile;
